import React, { ChangeEvent } from 'react';

import {
  InputGroup,
  Label,
  ElementWrap,
  ReasonSelect,
  SelectChevron,
  FieldSubText,
  ReasonText,
  ReasonLength,
  CarrierText
} from '../cancelPolicyFormStyles';
import ChevronIconSrc from '../../../../assets/images/chevron-down.svg';
import CarrierMovedTo from './carrierMovedTo';

interface initialState {
  value: string;
  active: boolean;
  error: boolean;
  msg: string;
}

interface initialCPPState {
  customText: string;
  isactive: boolean;
  errors: boolean;
  msgs: string;
}

interface CancellationReasonProps {
  state: initialState;
  onFocus: Function;
  onBlur: Function;
  onChange: Function;
  disabled: boolean;
  reasonCode: string;
  setReasonCode: Function;
  cancellationSource: string;
  setCancellationSource: Function;
  product: string;
  systemCode: string;
  carrierMovedTo: string;
  setCarrierMovedTo: Function;
  otherCarrier: string;
  setOtherCarrier: Function;
  requestError: {
    requestError: boolean;
    requestMsg: string;
  };
  setRequestError: Function;
  carrierError: {
    carrierError: boolean;
    carrierMsg: string;
  };
  setCarrierError: Function;
  otherCarrierError: {
    otherError: boolean;
    otherMsg: string;
  };
  setOtherError: Function;
  cancellationCPPReason: initialCPPState;
  onFocusCPPReason: Function;
  onBlurCPPReason: Function;
  onChangeCPPReason: Function;
  onFocusReason: Function;
  onBlurReason: Function;
  onChangeReason: Function;
  isFarmRanchLine: boolean;
  isAgentSelected: boolean;
  setIsAgentSelected: Function;
  customTexts: string;
  setCustomText: Function;
}

export const reasonOptions: string[] = [
  'Select Reason for Cancellation',
  'Insured Request',
  'Insured Request / Moved out of State'
];

export const reasonCodes: { [key: string]: string; } = {
  'Insured Request': 'fincononpay',
  'Insured Request / Moved out of State': 'insuredRequestOrMovedOutState_Ext'
};

export const clReasonOptions: string[] = [
  'Select Reason for Cancellation',
  'Insured Request',
  'Moved To Other Carrier',
  'Policy Not Taken',
];

export const clReasonCode: { [key: string]: string; } = {
  'Insured Request': 'fincononpay',
  'Moved To Other Carrier': 'movedToOtherCarrier_SAI',
  'Policy Not Taken': 'nottaken',
};

export const wcReasonOptions: string[] = [
  'Select Reason for Cancellation',
  'Non-Payment of Premium'
];

export const wcReasonCode: { [key: string]: string; } = {
  'Non-Payment of Premium': 'nonpayment_Ext'
};

export const dropDownInitialState: initialState = {
  value: reasonOptions[0],
  active: false,
  error: false,
  msg: ''
};
export const textBoxInitialState: initialState = {
  value: '',
  active: false,
  error: false,
  msg: ''
};
export const textBoxCPPInitialState: initialCPPState = {
  customText: '',
  isactive: false,
  errors: false,
  msgs: ''
};

export const isValid = (value: string) =>
  value !== reasonOptions[0] && value !== '';


const selectedLabel = (value: string, codes: Record<string, string>): string => {
  return Object.keys(codes).find(
    (label) => codes[label] === value
  ) || '';
};

export default ({
  state: { value, active, error, msg },
  onFocus,
  onBlur,
  onChange,
  disabled,
  reasonCode,
  setReasonCode,
  cancellationSource,
  setCancellationSource,
  product,
  systemCode,
  carrierMovedTo,
  setCarrierMovedTo,
  otherCarrier,
  setOtherCarrier,
  requestError: { requestError, requestMsg },
  setRequestError,
  carrierError,
  setCarrierError,
  otherCarrierError: { otherError, otherMsg },
  setOtherError,
  cancellationCPPReason: { customText, isactive, errors, msgs },
  onFocusCPPReason,
  onBlurCPPReason,
  onChangeCPPReason,
  onFocusReason,
  onBlurReason,
  onChangeReason,
  isFarmRanchLine,
  isAgentSelected,
  setIsAgentSelected,
  customTexts,
  setCustomText
}: CancellationReasonProps) => (
  <div>
    {systemCode === 'GWPL' &&
      <InputGroup test-attr="cancel-policy-cancellation-reason">
        <Label active={active} error={error}>
          Reason
        </Label>
        <ElementWrap active={active} error={error}>
          <ReasonSelect
            value={selectedLabel(value, reasonCodes)}
            onChange={(e: ChangeEvent<HTMLSelectElement>) => {
              if (reasonCodes[e.target.value]) {
                value = e.target.value;
                // setReasonCode(reasonCodes[e.target.value]);
                onChange(reasonCodes[e.target.value]);
              }
            }}
            disabled={disabled}
          >
            {reasonOptions.map(option => (
              <option key={option} value={option} style={{ fontSize: '15px' }}>
                {option}
              </option>
            ))}
          </ReasonSelect>
          <SelectChevron src={ChevronIconSrc} />
        </ElementWrap>
        <FieldSubText error={error}>{msg}</FieldSubText>
      </InputGroup>}
    {systemCode === 'GWCL' &&
      <div>
        {((product === 'COMMERCIAL PACKAGE' || product === 'Commercial Property' || product === 'WORKERS COMP' || product === 'General Liability' || product === 'Inland Marine') || isFarmRanchLine) && (
          <div>
            {(!isFarmRanchLine) && (
              <InputGroup test-attr="cancel-policy-cancellation-source">
                <Label active={active} error={requestError}>
                  Request By
                </Label>
                <ElementWrap active={active} error={requestError}>
                  <ReasonSelect
                    value={cancellationSource}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                      cancellationSource = (e.target.value);
                      setCancellationSource(e.target.value);
                      setRequestError({ requestError: false, requestMsg: '' });
                      setIsAgentSelected(e.target.value === 'Agent');
                      if (e.target.value === 'Agent') {
                        setCustomText('Cancellation for non-payment of premium');
                        setReasonCode(clReasonCode[3]);

                      } else {
                        setCustomText('');
                      }
                      console.log('CUSTOM TEXT:', customText);
                    }}
                    disabled={disabled}
                  >
                    <option key="default" style={{ fontSize: '15px' }}>Select Requested By</option>
                    {/* Commenting below to not show 'Agent' option in dropdown. */}
                    {/* {(product === 'WORKERS COMP') && <option key="Agent" style={{ fontSize: '15px' }}>Agent</option>} */}
                    <option key="Insured" style={{ fontSize: '15px' }}>Insured</option>
                  </ReasonSelect>
                  <SelectChevron src={ChevronIconSrc} />
                </ElementWrap>
                <FieldSubText error={requestError}>{requestMsg}</FieldSubText>
              </InputGroup>
            )}

            {(!isFarmRanchLine) &&
              <InputGroup test-attr="cancel-policy-cancellation-reason-cpp-wc">
                <Label active={active} error={error}>
                  Reason
                </Label>
                <ElementWrap active={active} error={error}>
                  <ReasonSelect
                    value={selectedLabel(value, clReasonCode)}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => {

                      if (clReasonCode[e.target.value]) {
                        value = e.target.value;
                        // setReasonCode(clReasonCode[e.target.value]);
                        onChange(clReasonCode[e.target.value]);
                      }
                    }}
                    disabled={disabled}
                  >
                    {!isAgentSelected && clReasonOptions.map(option => (
                      <option key={option} value={option} style={{ fontSize: '15px' }}>
                        {option}
                      </option>
                    ))}
                    {isAgentSelected && wcReasonOptions.map(option => (
                      <option key={option} value={option} style={{ fontSize: '15px' }}>
                        {option}
                      </option>))}
                  </ReasonSelect>
                  <SelectChevron src={ChevronIconSrc} />
                </ElementWrap>
                <FieldSubText error={error}>{msg}</FieldSubText>
              </InputGroup>
            }
            {selectedLabel(value, clReasonCode) === clReasonOptions[2] && (
              <CarrierMovedTo
                carrierMovedTo={carrierMovedTo}
                setCarrierMovedTo={setCarrierMovedTo}
                disabled={disabled}
                product={product}
                carrierError={carrierError}
                setCarrierError={setCarrierError}
              />
            )}
            {selectedLabel(value, clReasonCode) === clReasonOptions[2] && carrierMovedTo === 'Other' && (
              <div>
                <InputGroup test-attr="cancel-policy-cancellation-other-carrier">
                  <Label active={active} error={otherError}>
                    Enter Other Carrier
                  </Label>
                  <CarrierText
                    type="text"
                    onFocus={() => onFocus()}
                    onBlur={() => onBlur()}
                    value={otherCarrier}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      setOtherCarrier(e.target.value);
                      setOtherError({ otherError: false, otherMsg: '' });
                    }}
                    placeholder="Other Carrier"
                  />
                  <FieldSubText error={otherError}>{otherMsg}</FieldSubText>
                </InputGroup>
              </div>
            )}
            {/* THIS IS CPP REASON, IT IS MANDATORY */}
            <InputGroup test-attr="cancel-policy-cancellation-reason-cpp">
              <Label active={isactive} error={errors}>
                Reason for Cancellation
              </Label>
              <ReasonText
                required={true}
                maxLength={250}
                onBlur={() => onBlurReason()}
                value={customTexts}
                placeholder="Enter Reason for Cancellation"
                onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                  setCustomText(e.target.value);
                  onChangeCPPReason(e.target.value);
                  setReasonCode('fincononpay');
                }}
              />
              <ReasonLength>{value.length}/250</ReasonLength>
            </InputGroup>
          </div>
        )}
        {(product === 'Businessowners Line' || product === 'Commercial Umbrella Line' || product === 'Commercial Auto Line (v7)') &&
          <div>
            <InputGroup test-attr="cancel-policy-cancellation-reason-bo-cu-ca">
              <Label active={active} error={error}>
                Reason for Cancellation
              </Label>
              <ReasonText
                maxLength={250}
                onFocus={() => onFocus()}
                onBlur={() => onBlur()}
                value={value}
                placeholder="Enter Reason for Cancellation (optional)"
                onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                  onChange(e.target.value);
                  setReasonCode('fincononpay');
                }}
              />
              <ReasonLength>{value.length}/250</ReasonLength>
            </InputGroup>
          </div>

        }
      </div>
    }

  </div>
);
